import React, { useState } from 'react';
import PropTypes from 'prop-types';
import type { HeaderProps, MenuOptionProps } from './Header.types';
import Icon from '../icon/Icon';
import './header.scss';

const Header = ({ logo, userName, userRole, userImage, announcements, menuOptions, topOptions, notificationsEvent, notificationsQuantity }: HeaderProps) => {
  const [open, setOpen] = useState(false);

  const RenderIcon = ({ iconName, quantity, event }: MenuOptionProps) => {
    return <div
      className="sb-header__content--option"
      onClick={event && event}
    >
      {!!(quantity ?? 0) &&
        <span className="sb-header__content--option-number">
          {quantity === 1 ?
            quantity :
            `${quantity ? (quantity - 1) : 0}+`}
        </span>
      }
      <Icon
        iconName={iconName}
        size={19.7}
        style={{ color: '#3C4662' }}
        className="cursor-pointer ml-lg"
      />
    </div>
  }

  return (
    <header
      className="sb-header"
      data-testid="sb-header"
    >
      <div
        className="sb-header__container"
        data-testid="sb-header__container"
      >
        {logo &&
          <img
            className="sb-header__container--logo"
            data-testid="sb-header__container--logo"
            src={logo}
            alt="Logo header"
          />}
        <div
          className="sb-header__content"
          data-testid="sb-header__content"
        >
          <div className="sb-header__options-icon hidden md:flex">
            {topOptions && topOptions.length > 0 && topOptions.map((option, index) => <RenderIcon
              iconName={option.iconName}
              quantity={option.quantity}
              key={`sb-header__content--option-${index}`}
            />)}
          </div>
          {announcements &&
            <Icon
              iconName="megaphone"
              size={20}
              style={{ color: '#001C39' }}
              className="cursor-pointer mx-md"
            />
          }
          <RenderIcon
            iconName="bell"
            quantity={notificationsQuantity}
            event={notificationsEvent}
            key={`sb-header__content--option-100`}
          />
          {!announcements &&
            <div className="sb-header__content--user">
              <p>
                Hola, <strong>{userName}</strong>
              </p>
              <span>
                {userRole}
              </span>
            </div>
          }
          <img
            className="sb-header__content__image"
            data-testid="sb-header__content__image"
            src={userImage}
            alt=""
          />
          <div
            className={`sb-header__logout ${open && 'sb-header__logout--open'}`}
            data-testid="sb-header__logout"
          >
            <Icon
              iconName="chevron-down"
              size={22}
              className="cursor-pointer"
              onClick={() => { setOpen(!open) }}
            />
            <div
              className="sb-header__logout--tooltip"
              data-testid="sb-header__logout--tooltip"
            >
              {menuOptions && menuOptions.length > 0 && menuOptions.map((option, index) => {
                return <div
                  onClick={() => { setOpen(!open) }}
                  key={`option-${index}`}
                  data-testid="sb-header__option"
                  className="sb-header__option"
                >
                  {option.iconName &&
                    <Icon
                      iconName={option.iconName}
                      size={14.5}
                      className="cursor-pointer mr-sm"
                      onClick={() => { setOpen(!open) }}
                    />
                  }
                  {option.text}
                </div>
              })}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  /**
* logo
*/
  logo: PropTypes.string,
  /**
* userName
*/
  userName: PropTypes.string,
  /**
* userRole
*/
  userRole: PropTypes.string,
  /**
* userImage
*/
  userImage: PropTypes.string,
  /**
* show announcements?
*/
  announcements: PropTypes.bool,
  /**
* menuOptions
*/
  menuOptions: PropTypes.array,
  /**
* topOptions
*/
  topOptions: PropTypes.array,
  /**
* notifications event
*/
  notificationsEvent: PropTypes.func,
  /**
* notifications quantity
*/
  notificationsQuantity: PropTypes.number,

};

Header.defaultProps = {
  logo: "",
  userName: "",
  userImage: "",
  announcements: false,
  notificationsQuantity: 1,
  notificationsEvent: () => { },
  menuOptions: [],
  topOptions: []
};

export default Header;